import { colorGray200 } from '@amzn/meridian-tokens/base/color';

import { ColorCodes } from './ColorCodes';

const {
  LIGHT_TURQUOISE,
  MEDIUM_AQUAMARINE,
  TURQUOISE_GREEN,
  DARK_GRAY,
  DARK_BLUE,
  DARK_NAVY_BLUE,
  LIGHT_GRAY,
  ANTI_FLASH_WHITE,
} = ColorCodes;

export enum ProfileMenuInfo {
  QR_CODE_MESSAGE = 'Invite your customers to visit your webstore by putting a printout of the QR code in your shop or on your order packaging',
  QR_CODE_ERROR = 'Currently unable to download QR',
  SHARE = 'Share',
  SHARE_LINK = 'Share Link',
  SHARE_QR_CODE = 'Share QR Code',
  VISIT_ONLINE_STORE = 'Visit the online store',
  DOWNLOAD_QR_CODE = 'Download QR Code',
  QR_FILE_NAME = 'qr_code.svg',
  QR_BLOB_FILE_TYPE = 'image/svg+xml;charset=utf-8',
  QR_DOCUMENT_ID = '12345',
  QR_CREATE_ELEMENT = 'a',
  CATEGORIES = 'Categories',
  CATEGORIES_ERROR = 'Unable to find your categories!',
  STORE_ADDRESS = 'Store Address',
  STORE_NUMBER = 'Store Number',
  PREFIX_STORE_NUMBER = '+91',
  ACCEPT_ORDER = 'Accept Orders',
  STORE_ACTIVE = 'storeActive',
  DELIVERY = 'Delivery',
  PICK_UP = 'Pickup',
  BOPIS_SUPPORTED = 'bopisSupported',
  DELIVERY_SUPPORTED = 'deliverySupported',
  EDIT_PROFILE = 'Edit Profile',
  SHARE_STORE = 'Share store',
  LOGOUT = 'Logout',
  STORE_TIMINGS = 'Store Timings',
  STORE_STATUS = 'Store Status',
  FAILED_TO_ADD_CHANGES = 'Failed to add changes.',
  FAILED_TO_LOGOUT = 'Failed to logout!',
  YES = 'Yes',
  NO = 'No',
  OFF = 'Off',
  ON = 'On',
  CLOSED = 'Closed',
  HTTPS = 'https://',
  ACTIVE = 'ACTIVE',
  MANAGE = 'Manage',
  STORES = 'Stores'
}

export const OrderedDays: string[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const DatesAbbreviations: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const ProfileMenuTokens = {
  loaderIndicatorBackgroundColor: DARK_GRAY,
  toggleTrackBackgroundColorSelectedDefault: TURQUOISE_GREEN,
  toggleTrackBackgroundColorSelectedHover: MEDIUM_AQUAMARINE,
  toggleTrackBackgroundColorSelectedPressed: MEDIUM_AQUAMARINE,
  toggleTrackBackgroundColorUnselectedHover: LIGHT_TURQUOISE,
  dividerColor: colorGray200,
  buttonBackgroundColorPrimaryDefault: DARK_BLUE,
  buttonBackgroundColorPrimaryHover: DARK_NAVY_BLUE,
  buttonBackgroundColorPrimaryDisabled: LIGHT_GRAY,
  buttonBackgroundColorPrimaryPressed: DARK_NAVY_BLUE,
  buttonForegroundColorPrimaryDisabled: ANTI_FLASH_WHITE,
  linkForegroundColorDefault: TURQUOISE_GREEN,
  linkForegroundColorHover: MEDIUM_AQUAMARINE,
  linkForegroundColorPressed: MEDIUM_AQUAMARINE,
};
